// this reducer stores all the local info used for Let's Roam Local
// local data can be refetched with global.localDataRefetch

import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  //treasure data
  localView: 'list', //[list, map]
  localLocations: {}, // all let's roam local locations as object
  localLocationsList: [], // filtered and order local locations
  selectedLocalLocationId: null, // the currently viewed local spot (usually in the modal)
  locationTagTypes: [], // all the tag types
  localCompletions: {}, // all the completions
  localCompletionsList: [], // all the completions
  localChallenges: {}, // all the challenges
  localChallengesList: [], // all the challenges
  localLeaderboard: [],

  localFavorites: [], // all locally favorited locations
  localFilters: {
    // filteres for let's roam local
    tag_ids: [],
    star_ratings: [],
    filter_count: 0,
  },
};

const localSlice = createSlice({
  name: 'local',
  initialState,
  reducers: {
    updateLocalView(state, {payload: localView}) {
      state.localView = localView;
    },
    updateSelectedLocalLocationId(state, {payload: selectedLocalLocationId}) {
      state.selectedLocalLocationId = selectedLocalLocationId;
    },
    setLocalLocations(state, {payload: localLocations}) {
      state.localLocations = localLocations;
    },
    setLocalLocationsList(state, {payload: localLocationsList}) {
      state.localLocationsList = localLocationsList;
    },
    setLocationTagTypes(state, {payload: locationTagTypes}) {
      state.locationTagTypes = locationTagTypes;
    },
    setLocalCompletions(state, {payload}) {
      console.log('setLocalCompletions', {
        localCompletions: {
          ...state.localCompletions,
          ...payload.localCompletions,
        },
      });
      return {
        ...state,
        localCompletions: payload.localCompletions,
      };
    },
    setLocalCompletionsList(state, {payload: localCompletionsList}) {
      state.localCompletionsList = localCompletionsList;
    },
    setShowCreateChallengeModal(state, {payload: showCreateChallengeModal}) {
      console.log('setShowCreateChallengeModal', {showCreateChallengeModal});
      state.showCreateChallengeModal = showCreateChallengeModal;
    },
    setLocalChallenges(state, {payload: localChallenges = {}}) {
      console.log(
        'setLocalChallenges',
        // localChallenges: localChallenges,
      );
      const newLocalChallenges = {
        ...(state.localChallenges || {}),
        ...(localChallenges || {}),
      };
      return {
        ...state,
        localChallenges: newLocalChallenges,
        localChallengesList: Object.values(newLocalChallenges || {}),
      };
    },
    setLocalFavorites(state, {payload: localFavorites}) {
      state.localFavorites = localFavorites;
    },
    setLocalLeaderboard(state, {payload: localLeaderboard}) {
      state.localLeaderboard = localLeaderboard;
    },
    setLocalFilters(state, {payload}) {
      console.log('setLocalFiltersReducer', {
        localFilters: payload,
      });
      const hasTagFilter = payload.tag_ids?.length > 0;
      const hasStarFilter = payload.star_ratings?.length > 0;
      const hasTitleFilter = !!payload?.title;
      return {
        ...state,
        localFilters: {
          ...payload,
          hasStarFilter,
          hasTagFilter,
          hasTitleFilter,
          filter_count: 0 + hasStarFilter + hasTagFilter + hasTitleFilter,
        },
      };
    },
    clearLocalFilters(state, {payload}) {
      console.log('setLocalFiltersReducer', {
        localFilters: payload,
      });

      return {
        ...state,
        localFilters: {
          hasStarFilter: 0,
          hasTagFilter: 0,
          hasTitleFilter: 0,
          filter_count: 0,
          title: null,
          tag_ids: [],
          star_ratings: [],
        },
      };
    },
  },
});

export const {
  updateLocalView,
  updateSelectedLocalLocationId,
  setLocalLocations,
  setLocalLocationsList,
  setLocationTagTypes,
  setLocalCompletions,
  setLocalCompletionsList,
  setLocalChallenges,
  setLocalFavorites,
  setLocalFilters,
  clearLocalFilters,
  setShowCreateChallengeModal,
  setLocalLeaderboard,
} = localSlice.actions;
export default localSlice.reducer;
